import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface ParcelListActionCellRendererParams extends ICellRendererParams {
    canSetReporting: (params: ParcelListActionCellRendererParams) => boolean;
    setReporting: (params: ParcelListActionCellRendererParams) => void;
    canRemoveReporting: (params: ParcelListActionCellRendererParams) => boolean;
    removeReporting: (params: ParcelListActionCellRendererParams) => void;
    canSetConsolidated: (params: ParcelListActionCellRendererParams) => boolean;
    setConsolidated: (params: ParcelListActionCellRendererParams) => void;
    canRemoveConsolidated: (params: ParcelListActionCellRendererParams) => boolean;
    removeConsolidated: (params: ParcelListActionCellRendererParams) => void;
    canOptOutConsolidated: (params: ParcelListActionCellRendererParams) => boolean;
    optOutConsolidated: (params: ParcelListActionCellRendererParams) => void;
    canOptInConsolidated: (params: ParcelListActionCellRendererParams) => boolean;
    optInConsolidated: (params: ParcelListActionCellRendererParams) => void;
    stateAllowConsolidating: (params: ParcelListActionCellRendererParams) => boolean;
}

@Component({
    selector: 'parcel-tile-grid-action-cell',
    template:
        `
        @if (params.canSetReporting(params)) {
          <button
            class="ace-btn btn-primary has-icon grid-action-button"
            helpTooltip
            helpContentId="parcel-list-panel.set-reporting"
            position="bottom"
            (click)="params.setReporting(params)">
            <i class="fa fa-file-text-o"></i>
          </button>
        }
        @if (params.canRemoveReporting(params)) {
          <button
            class="ace-btn btn-primary btn-danger has-icon grid-action-button"
            helpTooltip
            helpContentId="parcel-list-panel.remove-reporting"
            position="bottom"
            (click)="params.removeReporting(params)">
            <i class="fa fa-file-text-o"></i>
          </button>
        }
        @if (!(params.canSetReporting(params) || params.canRemoveReporting(params))) {
          <span>
            <i class="fa fa-fw"></i>
          </span>
        }
        @if (params.canSetConsolidated(params)) {
          <button
            class="ace-btn btn-primary has-icon grid-action-button"
            helpTooltip
            [helpContentId]="params.stateAllowConsolidating(params) ? 'parcel-list-panel.set-state-consolidated':'parcel-list-panel.set-site-consolidated'"
            position="bottom"
            (click)="params.setConsolidated(params)">
            <i class="fa fa-sitemap"></i>
          </button>
        }
        @if (params.canRemoveConsolidated(params)) {
          <button
            class="ace-btn btn-primary btn-danger has-icon grid-action-button"
            helpTooltip
            [helpContentId]="params.stateAllowConsolidating(params) ? 'parcel-list-panel.remove-state-consolidated':'parcel-list-panel.remove-site-consolidated'"
            position="bottom"
            (click)="params.removeConsolidated(params)">
            <i class="fa fa-sitemap"></i>
          </button>
        }
        @if (params.canOptOutConsolidated(params)) {
          <button
            class="ace-btn btn-primary btn-danger has-icon grid-action-button"
            helpTooltip
            helpContentId="parcel-list-panel.opt-out-consolidated"
            position="bottom"
            (click)="params.optOutConsolidated(params)">
            <i class="fa fa-sitemap"></i>
          </button>
        }
        @if (params.canOptInConsolidated(params)) {
          <button
            class="ace-btn btn-primary has-icon grid-action-button"
            helpTooltip
            helpContentId="parcel-list-panel.opt-in-consolidated"
            position="bottom"
            (click)="params.optInConsolidated(params)">
            <i class="fa fa-sitemap"></i>
          </button>
        }
        `,
    standalone: false
})
export class ParcelListActionCellRendererComponent implements ICellRendererAngularComp {
    params: ParcelListActionCellRendererParams;

    agInit(params: ParcelListActionCellRendererParams): void {
        this.params = params;
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }
}
